export { registerComponent as registerNavigationComponent } from '../../components/builtin/Navigation/register'
export { default as Navigation } from '../../components/builtin/Navigation/Navigation'
